/* Live Free — add to cart. The only JS in the buy path.
   Posts to /cart/add.js, swaps the button through its states, and refreshes the
   header count. Falls back to a normal form POST if fetch is unavailable. */
(function () {
  'use strict';
  if (!window.fetch) return;

  function setLabel(btn, key) {
    var text = btn.dataset['lfLabel' + key];
    if (text) btn.textContent = text;
  }

  // The header badge is Prestige's; keep it honest after an async add.
  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count, [data-cart-count], .lf-head__cart-count')
          .forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-lf-atc]');
    if (!form) return;

    var btn = form.querySelector('[data-lf-atc-btn]');
    if (!btn) return;

    event.preventDefault();
    btn.disabled = true;
    setLabel(btn, 'Loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        setLabel(btn, 'Added');
        btn.classList.add('is-added');
        refreshCount();
        window.setTimeout(function () {
          setLabel(btn, 'Idle');
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        setLabel(btn, 'Error');
        window.setTimeout(function () {
          setLabel(btn, 'Idle');
          btn.disabled = false;
        }, 2000);
      });
  });
})();